export enum GroupByField {
  DUE_DATE = 'dueDate',
  READING = 'readingSource',
  CATEGORY = 'taskCategoryId',
  ALL = ''
}
